import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const SearchAutocompleteLoadingUi = styled.span`
  margin: 0;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  border-width: 2px;
  border-style: solid;
  color: var(--color-primary-500, #3b82f6);
  border-color: currentColor;
  border-top-color: transparent;
  animation: ${spin} 1s linear infinite;
`
